import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

function fmt(sym, price) {
  if (price === null || price === undefined) return "—";
  if (sym === "BTC" || sym === "ETH") {
    return `$${price >= 100 ? price.toLocaleString("en-US", { maximumFractionDigits: 0 }) : price.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
  }
  // Gold / Silver — show 2 decimals
  return `$${price.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
}

function fmtPct(v) {
  if (v === null || v === undefined) return "—";
  const s = v >= 0 ? "+" : "";
  return `${s}${v.toFixed(2)}%`;
}

const ACCENT = {
  BTC: "text-amber-300",
  ETH: "text-sky-300",
  XAU: "text-yellow-300",
  XAG: "text-slate-300",
};

export default function MarketTicker() {
  const [items, setItems] = useState([]);
  const [ok, setOk] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/market/ticker");
      setItems(data.items || []);
      setOk(true);
    } catch {
      setOk(false);
    }
  };

  useEffect(() => {
    load();
    const int = setInterval(load, 60 * 1000);
    return () => clearInterval(int);
  }, []);

  if (!ok && items.length === 0) {
    return (
      <div className="w-full border-b border-border bg-card/70 backdrop-blur-md" data-testid="market-ticker-unavailable">
        <div className="max-w-7xl mx-auto px-4 py-1.5 text-[10px] tracking-[0.25em] uppercase text-muted-foreground/60">
          Live ticker temporarily unavailable — retrying…
        </div>
      </div>
    );
  }

  return (
    <div className="w-full border-b border-border bg-card/70 backdrop-blur-md" data-testid="market-ticker">
      <div className="max-w-7xl mx-auto flex items-center gap-3 sm:gap-6 px-3 sm:px-4 py-1.5 overflow-x-auto hide-scroll">
        <span className="text-[9px] tracking-[0.25em] uppercase text-muted-foreground shrink-0">Live</span>
        {items.map(it => {
          const hasChg = it.change_pct !== null && it.change_pct !== undefined;
          const up = hasChg ? it.change_pct >= 0 : null;
          return (
            <div key={it.symbol} data-testid={`ticker-${it.symbol}`}
              className="flex items-center gap-2 shrink-0 text-xs">
              <span className={`font-mono font-bold ${ACCENT[it.symbol] || "text-foreground"}`}>{it.symbol}</span>
              <span className="font-mono-num text-foreground">{fmt(it.symbol, it.price)}</span>
              {hasChg && (
                <span className={`font-mono-num text-[11px] ${up ? "text-emerald-500 dark:text-emerald-400" : "text-red-500 dark:text-red-400"}`}>
                  {up ? "▲" : "▼"} {fmtPct(it.change_pct)}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
